// extracted by mini-css-extract-plugin
export default {"links":"GroupSettings_links__ppeLk","link":"GroupSettings_link__qPptG","current":"GroupSettings_current__ZTecJ","container":"GroupSettings_container__ke2uP"};